'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _RecipientsListItem = require('components/Recipients/RecipientsListItem/RecipientsListItem');

var _RecipientsListItem2 = _interopRequireDefault(_RecipientsListItem);

var _RecipientsListHeader = require('components/Recipients/RecipientsListHeader/RecipientsListHeader');

var _RecipientsListHeader2 = _interopRequireDefault(_RecipientsListHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientsList = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(RecipientsList, _PureComponent);

  function RecipientsList() {
    (0, _classCallCheck3.default)(this, RecipientsList);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientsList.__proto__ || (0, _getPrototypeOf2.default)(RecipientsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loading = _props.loading,
          recipients = _props.recipients,
          deleteLoaders = _props.deleteLoaders,
          activeOrder = _props.activeOrder,
          order = _props.order;
      var _props2 = this.props,
          onDelete = _props2.onDelete,
          onEdit = _props2.onEdit,
          onReorder = _props2.onReorder,
          onClick = _props2.onClick;


      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _components.List,
          null,
          _react2.default.createElement(_RecipientsListHeader2.default, {
            activeOrder: activeOrder,
            order: order,
            onReorder: onReorder
          }),
          recipients.map(function (recipient) {
            return _react2.default.createElement(_RecipientsListItem2.default, {
              key: recipient.id,
              recipient: recipient,
              onClick: onClick,
              onDelete: onDelete,
              onEdit: onEdit,
              deleteLoaders: deleteLoaders
            });
          })
        ),
        _react2.default.createElement(_components.Loader, { show: loading, alignCenter: true })
      );
    }
  }]);
  return RecipientsList;
}(_react.PureComponent), _class.propTypes = {
  activeOrder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  deleteLoaders: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onReorder: _propTypes2.default.func,
  order: _propTypes2.default.object,
  recipients: _propTypes2.default.array.isRequired
}, _class.defaultProps = {
  onDelete: _noop3.default,
  onEdit: _noop3.default,
  onReorder: _noop3.default,
  recipients: [],
  loading: false
}, _temp);
exports.default = RecipientsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/RecipientsList/RecipientsList.js
// module id = 2090
// module chunks = 1